import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Pencil, Plus, Trash2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import AdminCard from "../AdminCard";
import TemplateEditModal from "./TemplateEditModal";

export const TemplatesPanel = () => {
    const [templates, setTemplates] = useState([]);
    const [editing, setEditing] = useState(null);
    const load = () => api.get("/mailing/templates").then((r) => setTemplates(r.data || [])).catch(() => toast.error("Nie udało się wczytać szablonów."));
    useEffect(() => { load(); }, []);

    const del = async (t) => {
        if (!window.confirm(`Usunąć szablon „${t.name}”?`)) return;
        try { await api.delete(`/mailing/templates/${t.id}`); toast.success("Usunięto szablon."); load(); }
        catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    };

    return (
        <AdminCard>
            <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
                <div>
                    <h3 className="font-serif text-xl text-[#092E22]">Szablony wiadomości ({templates.length})</h3>
                    <p className="text-xs text-gray-500">Wybierasz je w kreatorze kampanii przyciskiem „Szablony”.</p>
                </div>
                <Button onClick={() => setEditing({})} className="rounded-full bg-[#0D4F3C] hover:bg-[#092E22] text-white" data-testid="mailing-template-new"><Plus size={14} className="mr-1.5" />Nowy szablon</Button>
            </div>
            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-3" data-testid="mailing-template-list">
                {templates.map((t) => (
                    <div key={t.id} className="p-4 rounded-2xl bg-[#FAF8F3] border border-gray-100 flex flex-col" data-testid={`mailing-template-${t.id}`}>
                        <p className="text-[10px] uppercase tracking-widest text-[#B88A26]">{t.category}{t.seed_key ? " · startowy" : ""}</p>
                        <p className="font-semibold text-sm text-[#092E22] mt-1">{t.name}</p>
                        <p className="text-xs text-gray-500 mt-1 line-clamp-2 flex-1">{t.subject}</p>
                        <div className="flex items-center justify-between mt-3">
                            <span className="text-[10px] font-mono text-gray-400 truncate">{t.fields.map((f) => `[${f}]`).join(" ")}</span>
                            <span className="flex gap-1 shrink-0">
                                <button onClick={() => setEditing(t)} className="p-1.5 rounded-lg text-[#0D4F3C] hover:bg-white" data-testid={`mailing-template-edit-${t.id}`}><Pencil size={14} /></button>
                                <button onClick={() => del(t)} className="p-1.5 rounded-lg text-red-500 hover:bg-white" data-testid={`mailing-template-delete-${t.id}`}><Trash2 size={14} /></button>
                            </span>
                        </div>
                    </div>
                ))}
            </div>
            {editing && <TemplateEditModal initial={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
        </AdminCard>
    );
};

export default TemplatesPanel;
